import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { ExpandStateService } from '../../common/expand-state.service';
/**
 * @hidden
 */
var DetailsService = /** @class */ (function (_super) {
    tslib_1.__extends(DetailsService, _super);
    function DetailsService() {
        return _super.call(this, true) || this;
    }
    DetailsService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    DetailsService.ctorParameters = function () { return []; };
    return DetailsService;
}(ExpandStateService));
export { DetailsService };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/rendering/details/details.service.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/rendering/details/details.service.js
// module chunks = vendor